import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { Printer, Loader2 } from "lucide-react";
import { AgreementBody, fmtDate } from "@/components/legal/AgreementBody";

export default function AgreementView() {
  const { id } = useParams();
  const [ag, setAg] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    api.get(`/legal/agreements/${id}`).then((r) => {
      setAg(r.data);
      if (new URLSearchParams(window.location.search).get("print")) setTimeout(() => window.print(), 400);
    }).catch(() => setErr(true));
  }, [id]);
  if (err) return <div className="max-w-3xl mx-auto px-6 py-16 text-slate-600" data-testid="agreement-view-missing">Document not found.</div>;
  if (!ag) return <div className="py-20 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-slate-400" /></div>;
  return (
    <article className="max-w-3xl mx-auto px-5 sm:px-8 py-10" data-testid="agreement-view">
      <div className="flex flex-wrap items-start justify-between gap-3 print:hidden">
        <div className="text-xs font-bold uppercase tracking-widest text-cyan-700">Cyannect Terms &amp; Privacy</div>
        <button onClick={() => window.print()} className="pf-btn-glass px-4 py-2 rounded-full text-xs font-semibold inline-flex items-center gap-1" data-testid="agreement-view-print">
          <Printer className="w-3 h-3" /> Print / save as PDF
        </button>
      </div>
      <h1 className="font-display text-4xl sm:text-5xl text-slate-900 mt-3" data-testid="agreement-view-title">{ag.title}</h1>
      <div className="text-sm text-slate-500 mt-2" data-testid="agreement-view-meta">
        Version {ag.version} · Effective {fmtDate(ag.effective_at)} {ag.status === "RETIRED" && "· Retired"}
      </div>
      <div className="text-[11px] text-slate-400 font-mono break-all mt-1" data-testid="agreement-view-hash">SHA-256 {ag.document_hash_sha256}</div>
      <hr className="my-6 border-slate-200" />
      <AgreementBody text={ag.document_plaintext} />
    </article>
  );
}
